var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { ApplicationContext } from '../../../../ApplicationContext';
import { Roles } from "../../../../data/Roles";
import SchemaTriggerType from '../../../../data/SchemaTriggerType';
import Routes from '../../../../routes/RoutesConfig';
import Signals from '../../../../signals/Signals';
import Role from "../Role/Role";
import ServiceSchemaOption from './ServiceSchemaOption';
/**
 *
 */
var ServiceSchemaSearch = /** @class */ (function (_super) {
    __extends(ServiceSchemaSearch, _super);
    /**
     *
     * @param props
     */
    function ServiceSchemaSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = _this.onChange.bind(_this);
        _this.onUpdate = _this.onUpdate.bind(_this);
        _this.state = {};
        return _this;
    }
    /**
     *
     * @return {*}
     */
    ServiceSchemaSearch.prototype.render = function () {
        var _a = this.props, name = _a.name, intl = _a.intl, className = _a.className, value = _a.value;
        var _b = this.state;
        var classes = classNames({ 'w-100': true }) + ' ' + className;
        return (React.createElement("div", { className: "service-schema-search d-flex flex-wrap ".concat(classes) },
            React.createElement("div", { className: "service-schema-search__input-wrapper w-100" },
                React.createElement(Select, { className: "form-control select2", classNamePrefix: "select2", name: name, placeholder: intl.formatMessage({ id: 'service.schema.search' }), noOptionsMessage: function () {
                        return intl.formatMessage({ id: 'service.schema.noresults' });
                    }, components: { Option: ServiceSchemaOption }, value: value ? {
                        value: value.id,
                        label: value.name,
                        model: value
                    } : null, isSearchable: true, options: this._createOptions(), onChange: this.onChange, isOptionDisabled: function (option) { return option.value == null || option.isDisabled; } })),
            React.createElement(Role, { roles: [Roles.OWNER] },
                React.createElement("div", { className: "w-100 mt-2" },
                    React.createElement(Link, { to: Routes.SERVICE_SCHEMAS_ADD.getPath({}), onClick: function () {
                            Signals.HideOverlay.dispatch();
                            Signals.HideAssetDetail.dispatch();
                        } },
                        React.createElement("i", { className: "fe fe-plus-circle" }),
                        " ",
                        React.createElement(FormattedMessage, { id: "service.schema.add" }))))));
    };
    /**
     *
     * @param option
     */
    ServiceSchemaSearch.prototype.onChange = function (option) {
        if (this.props.onChange) {
            this.props.onChange(option.model);
        }
    };
    /**
     *
     * @param labelModel
     */
    ServiceSchemaSearch.prototype.onUpdate = function (labelModel) {
    };
    /**
     *
     * @return {{label: (*|string), value: *}[]|Array}
     * @private
     */
    ServiceSchemaSearch.prototype._createOptions = function () {
        var _a = this.props, serviceSchemaCollection = _a.serviceSchemaCollection, manualOnly = _a.manualOnly, intervalOnly = _a.intervalOnly, disableIds = _a.disableIds;
        var schemaModels = serviceSchemaCollection.filtered.map(function (schemaModel) {
            return (manualOnly && schemaModel.triggerType === SchemaTriggerType.MANUAL) ||
                (intervalOnly && schemaModel.triggerType === SchemaTriggerType.INTERVAL) ||
                (!manualOnly && !intervalOnly) ?
                schemaModel : null;
        });
        var options = schemaModels
            .filter(function (model) {
            return !!model;
        })
            .map(function (model) {
            return {
                value: model.id,
                label: model.name,
                model: model,
                isDisabled: disableIds.indexOf(model.id) >= 0
            };
        });
        options.unshift({ value: null, label: null, model: null });
        return options;
    };
    ServiceSchemaSearch.defaultProps = {
        className: '',
        placeholder: 'Selecteer label',
        manualOnly: false,
        intervalOnly: false,
        disableIds: []
    };
    ServiceSchemaSearch = __decorate([
        observer
    ], ServiceSchemaSearch);
    return ServiceSchemaSearch;
}(React.Component));
ServiceSchemaSearch.contextType = ApplicationContext;
export default injectIntl(ServiceSchemaSearch);
